module.exports = __webpack_public_path__ + "assets/img/network-3.7be3bec7.svg";